import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getAdmins } from '@/api/admins';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery, formatJson } from '@/utils/index';
import { exportJson2Excel } from '@/utils/excel';
import { getRoles } from '@/api/roles';
import Enabled from '@/components/Enabled/index.vue';
import { AdminModule } from '@/store/modules/admin';
import { isSuperAdmin } from '@/common';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.rolesList = [];
    this.listLoading = true;
    this.downloadLoading = false;
    this.loggedInAdmin = null;
    this.listQuery = {
      page: 1,
      limit: 10,
      fullName: undefined,
      emailAddress: undefined,
      mobileNumber: undefined,
      adminsRoleId: undefined,
      enabled: true,
      sort: 'id,ASC',
      filter: {
        fullName: '$contL',
        emailAddress: '$contL',
        mobileNumber: 'starts',
        enabled: '$eq',
        adminsRoleId: '$in'
      }
    };
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }];
    this.enableTypeOptions = [{
      key: true,
      value: 'Enable'
    }, {
      key: false,
      value: 'Disabled'
    }];
  }
  activated() {
    this.loggedInAdmin = AdminModule;
    this.getAdminRoles().then(() => {
      if (!this.listQuery.adminsRoleId || this.listQuery.adminsRoleId.length === 0) {
        delete this.listQuery.adminsRoleId; // Omit if no role IDs are present
      }
      this.getList();
    });
  }
  async getList() {
    try {
      this.listLoading = true;
      const data = await getAdmins(getQuery(this.listQuery));
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  _isSuperAdmin() {
    return isSuperAdmin();
  }
  async getAdminRoles() {
    try {
      this.listLoading = true;
      this.rolesList = await getRoles(getQuery({
        enabled: true,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq'
        }
      }));
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  getAllRoleIds() {
    return this.rolesList.map(role => role.id);
  }
  handleFilter() {
    // Check if adminsRoleId is empty or undefined
    if (!this.listQuery.adminsRoleId || this.listQuery.adminsRoleId.length === 0) {
      // Remove adminsRoleId from the query if no values are selected
      delete this.listQuery.adminsRoleId;
    } else {
      // Ensure it's an array when adminsRoleId has values
      this.listQuery.adminsRoleId = this.listQuery.adminsRoleId;
    }
    this.listQuery.page = 1;
    this.getList();
  }
  sortChange(data) {
    const {
      prop,
      order
    } = data;
    if (prop) {
      this.listQuery.sort = `${prop}, + (order === "ascending" ? "ASC" : "DESC")`;
      this.handleFilter();
    }
  }
  getSortClass(key) {
    const sort = this.listQuery.sort;
    return sort === `${key},ASC` ? 'ascending' : sort === `${key},DESC` ? 'descending' : '';
  }
  handleDownload() {
    this.downloadLoading = true;
    const tHeader = ['ID', 'Full Name', 'Email', 'Mobile Number', 'Status', 'timestamp'];
    const filterVal = ['id', 'fullName', 'emailAddress', 'mobileNumber', 'enabled', 'createdTimestamp'];
    const data = formatJson(filterVal, this.list);
    exportJson2Excel(tHeader, data, this.$tc('route.adminManagement.admins.title'));
    this.downloadLoading = false;
  }
  // canEdit(admin: IAdminData = null) {
  //   // null check
  //   if (!admin) {
  //     return false;
  //   }
  //   // check if editing self
  //   if (admin.id === this.loggedInAdmin.id) {
  //     return false;
  //   }
  //   // check if logged in adminsRoleId is greater or equal to the adminsRoleId of the admin being edited
  //   if (this.loggedInAdmin.adminsRoleId <= admin.adminsRoleId) {
  //     return true;
  //   }
  //   // disallow editing
  //   return false;
  // }
  canEdit(admin = null) {
    // null check
    if (!admin) {
      return false;
    }
    // check if editing self
    if (admin.id === this.loggedInAdmin.id) {
      if (admin.id === 1 && this.loggedInAdmin.id === 1) {
        return true;
      }
      return false;
    }
    // check if logged in adminsRoleIds contains a roleId that is less than or equal to any roleId in admin.adminsRole
    if (this.loggedInAdmin.adminsRoleIds.some(roleId => admin.adminsRole.some(adminRole => roleId <= adminRole.id))) {
      return true;
    }
    // disallow editing
    return false;
  }
};
default_1 = __decorate([Component({
  name: 'AdminList',
  components: {
    Pagination,
    Enabled
  }
})], default_1);
export default default_1;